var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", { staticClass: "titled" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.closeFan.apply(null, arguments)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          { staticClass: "scrollbar-check" },
          [
            _c("h2", [_vm._v(_vm._s(_vm.jobProfileItem.name))]),
            _vm._v(" "),
            _c("JonInfo", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "message",
                    fn: function() {
                      return [
                        _c("p", [
                          _vm._v("Der Job wird dir damit nicht mehr angezeigt.")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Falls du es dir anders überlegst, findest du ihn links unter "
                          ),
                          _c("b", [_vm._v("Kein Interesse")]),
                          _vm._v(".")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1459180167
              )
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "footer",
          [
            _c("Button", {
              attrs: {
                text: "Kein Interesse",
                icon: "checkmark",
                disabled: _vm.saving,
                loading: _vm.saving
              },
              on: { click: _vm.exclude }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h1", [_vm._v("Leider kein Interesse")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }